import type { DiskWithPrice } from "@/modules/disks/disksListQuery.ts";
import { PricingModal } from "@/modules/pricing/PricingModal.tsx";
import { ReplicaPrice } from "@/modules/pricing/ReplicaPrice.tsx";
import { pricesAtom } from "@/modules/pricing/pricingQuery.ts";
import { getSnapshotGbPrice } from "@/modules/pricing/resourcePricing.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import type { VirtualMachineStorageReplica } from "@warrenio/api-spec/spec.oats.gen";

export function DiskEstimatedReplicaPriceModal({
    disk,
    type,
    billingAccountId,
}: {
    disk: DiskWithPrice;
    type: VirtualMachineStorageReplica["type"];
    billingAccountId?: number;
}) {
    const priceList = useSuspenseQueryAtom(pricesAtom);

    const { location } = disk;
    const estimatedPrice = getSnapshotGbPrice(priceList, disk.size_gb);

    return (
        <div className="pb-4">
            <PricingModal defaultLocation={location} defaultHostPool={disk.storage_pool_uuid}>
                <ReplicaPrice type={type} price={estimatedPrice} billingAccountId={billingAccountId} />
            </PricingModal>
        </div>
    );
}
